import styled from 'styled-components';
import SearchableListControls from '../SearchableListControls';

export const ListControls = styled(SearchableListControls)`
  margin-bottom: 48px;
`;
